import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _document;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as Flows from '../flow';
import { connect, urlencoded } from '../utils';
import { MILLISECOND_IN_DAY } from '../constants';
export var Browser = /*#__PURE__*/function () {
  function Browser() {
    _classCallCheck(this, Browser);
  }

  _createClass(Browser, [{
    key: "setCookie",
    value: function () {
      var _setCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, value, options) {
        var _ref, _ref$path, path, _ref$expires, expires, cookie;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = options || {}, _ref$path = _ref.path, path = _ref$path === void 0 ? '/' : _ref$path, _ref$expires = _ref.expires, expires = _ref$expires === void 0 ? 10 : _ref$expires;
                cookie = "".concat(name, "=").concat(value, ";");
                cookie += "expires=".concat(new Date(Date.now() + expires * MILLISECOND_IN_DAY).toUTCString(), ";");
                cookie += "path=".concat(path, ";");
                document.cookie = cookie;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function setCookie(_x, _x2, _x3) {
        return _setCookie.apply(this, arguments);
      }

      return setCookie;
    }()
  }, {
    key: "getCookie",
    value: function () {
      var _getCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
        var invalid, cookie, _cookie$split, _cookie$split2, value;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                invalid = '\b=\b';
                cookie = "".concat(invalid, "; ").concat(document.cookie).split("; ".concat(name, "=")).pop().split('; ').shift();
                _cookie$split = cookie.split('='), _cookie$split2 = _slicedToArray(_cookie$split, 2), value = _cookie$split2[1];
                return _context2.abrupt("return", value === invalid ? '' : value);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCookie(_x4) {
        return _getCookie.apply(this, arguments);
      }

      return getCookie;
    }()
  }, {
    key: "removeCookie",
    value: function () {
      var _removeCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function removeCookie(_x5) {
        return _removeCookie.apply(this, arguments);
      }

      return removeCookie;
    }()
  }, {
    key: "setCache",
    value: function () {
      var _setCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name, value) {
        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!value) {
                  _context4.next = 6;
                  break;
                }

                data = JSON.stringify(value);

                if (!(typeof window.localStorage !== 'undefined')) {
                  _context4.next = 5;
                  break;
                }

                window.localStorage.setItem(name, data);
                return _context4.abrupt("return");

              case 5:
                return _context4.abrupt("return", this.setCookie(name, data));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setCache(_x6, _x7) {
        return _setCache.apply(this, arguments);
      }

      return setCache;
    }()
  }, {
    key: "getCache",
    value: function () {
      var _getCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
        var cookie;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(typeof window.localStorage !== 'undefined')) {
                  _context5.next = 4;
                  break;
                }

                _context5.t0 = window.localStorage.getItem(name);
                _context5.next = 7;
                break;

              case 4:
                _context5.next = 6;
                return this.getCookie(name);

              case 6:
                _context5.t0 = _context5.sent;

              case 7:
                cookie = _context5.t0;
                _context5.prev = 8;
                return _context5.abrupt("return", JSON.parse(cookie));

              case 12:
                _context5.prev = 12;
                _context5.t1 = _context5["catch"](8);

              case 14:
                return _context5.abrupt("return", null);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 12]]);
      }));

      function getCache(_x8) {
        return _getCache.apply(this, arguments);
      }

      return getCache;
    }()
  }, {
    key: "removeCache",
    value: function () {
      var _removeCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(name) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(typeof window.localStorage !== 'undefined')) {
                  _context6.next = 3;
                  break;
                }

                window.localStorage.removeItem(name);
                return _context6.abrupt("return");

              case 3:
                return _context6.abrupt("return", this.removeCookie(name));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function removeCache(_x9) {
        return _removeCache.apply(this, arguments);
      }

      return removeCache;
    }()
  }, {
    key: "request",
    value: function request(url, params) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', "".concat(url, "?").concat(urlencoded(params)));

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (200 <= xhr.status && xhr.status < 400) {
              try {
                var response = JSON.parse(xhr.responseText);
                resolve(response);
              } catch (error) {
                var rejection = new Error('Response body is invalid.');
                reject(rejection);
              }
            } else {
              var _rejection = new Error("Reqeust fail, status ".concat(xhr.status));

              reject(_rejection);
            }
          }
        };

        xhr.onerror = function () {
          var rejection = new Error("Reqeust fail, status ".concat(xhr.status));
          reject(rejection);
        };

        xhr.send(null);
      });
    }
  }]);

  return Browser;
}();

_defineProperty(Browser, "supported", typeof ((_document = document) === null || _document === void 0 ? void 0 : _document.cookie) !== 'undefined' || typeof XMLHttpRequest !== 'undefined');

export default connect(Flows)(Browser)();